// state event related unstable prefixes
// don't import this file directly, import '$unstable/prefixes'

export const MATRIX_STATE_ROOM_IMAGE_PACK_PROPERTY_NAME = 'm.room.image_pack';
export const MATRIX_UNSTABLE_STATE_ROOM_EMOTES_PROPERTY_NAME = 'im.ponies.room_emotes';
/**
 * unstable prefix for call rooms
 * defined in MSC3401 https://github.com/matrix-org/matrix-spec-proposals/pull/3401
 */
export const MATRIX_UNSTABLE_ROOM_TYPE_CALL_PROPERTY_NAME = 'org.matrix.msc3401.call';

export const MATRIX_UNSTABLE_ROOM_STYLING = 'eu.she-a.powerlevels_style';
